import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { DeleteAlertModal } from '../../components/modal/DeleteAlertModal';
import { endpoints } from '../../api/endpoints';
import { Actions } from '../../components/table/TableActions';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { Box, Button, Checkbox, Chip, CircularProgress, Grid, Paper, Tooltip, Typography } from '@mui/material';
import { TablePagination } from '../../components/pagination/Pagination';
import { LoadingButton } from '@mui/lab';
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { useForm } from 'react-hook-form';
import { useContext, useEffect, useState } from 'react';
import { ArrowDownward, ArrowUpward, Check, Checklist, ListAlt, Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import CustomSelect from '../../components/forms/select/CustomSelect';
import { useCrudForm } from '../../api/useCrudForm';
import { toast } from 'react-toastify';
import { CustomAlertModal } from '../../components/modal/customAlertModal';
import AlertDialog from '../../components/dialog/alertDialog';
import { getStatusColor } from '../customer/form/DetailsForm';
import { AppContext } from '../../contexts/AppContext';
import { useNavigate } from 'react-router-dom';

export default function LockerListTable({ refetchData, loading, setLoading, buttonLoading, setButtonLoading, count, setSkip, setTake, take, skip, setSelectedItem, setOpen, rows, lockerStatusList, setLockerStatusList, lockerTypeList, setLockerTypeList, lockerLocationList, setLockerLocationList, showApproved, setShowApproved }: { refetchData: any, loading: any, setLoading: any, buttonLoading: any, setButtonLoading: any, take: any, skip: any, setSkip: any, setTake: any, count: any, setOpen: any, setSelectedItem: any, rows: any, lockerStatusList: any, setLockerStatusList: any, lockerTypeList: any, setLockerTypeList: any, lockerLocationList: any, setLockerLocationList: any, showApproved: string, setShowApproved: any }) {

    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [openApproveModal, setOpenApproveModal] = useState(false);
    const [selectedId, setSelectedID] = useState<any | null>();
    const [selectedLocker, setSelectedLocker] = useState<readonly number[]>([]);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [importData, setImportData] = useState<any | null>();
    const [isImporting, setImportLoading] = useState(false)
    const [bulkLoading, setBulkLoading] = useState(false)

    const initialValues = { lockerType: '', lockerNo: '', lockerLocation: '', lockerStatus: '' }

    const { handleSubmit, control, formState: { errors, }, setValue, getValues } = useForm({
        defaultValues: initialValues
    })

    const onSuccess = () => {
        setOpenAlertModal(false)
        setOpenApproveModal(false)
        setSelectedID(null)
        refetchData({ isMainTable: showApproved })
    }

    const onError = () => {
        setOpenAlertModal(false)
        setOpenApproveModal(false)
        setSelectedID(null)
    }

    const deleteAction = (row: any) => {
        setSelectedID(row.id);
        setOpenAlertModal(true)
    }

    const editAction = (row: any) => {
        setSelectedItem(row)
        setOpen(true)
    }

    const navigate = useNavigate()
    const viewAction = (row: any) => {
        navigate(`/lockers/${row.id}?isMainTable=${row.isMainTable}`)
    }

    const handleSearchButtonClick = (values: any) => {
        setSkip(0)
        setTake(take)
        setButtonLoading(true)
        refetchData({ lockerNo: values?.lockerNo, lockerType: values?.lockerType, lockerLocation: values?.lockerLocation, lockerStatus: values?.lockerStatus, isMainTable: showApproved })
    };

    const resetSearch = () => {
        setValue("lockerType", '');
        setValue("lockerNo", '');
        setValue("lockerLocation", '');
        setValue("lockerStatus", '');
        setLoading(true)
        refetchData({ isMainTable: showApproved })
    };

    const { get, add, edit } = useCrudForm();
    const { user } = useContext(AppContext)

    const getFilterSelectData = () => {
        get({
            endpoints: endpoints.common.getLockerStatus,
            onSuccess: (data: any) => {
                setLockerStatusList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
        get({
            endpoints: endpoints.common.getLockerTypes,
            onSuccess: (data: any) => {
                setLockerTypeList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
        get({
            endpoints: endpoints.common.getLocations(),
            onSuccess: (data: any) => {
                setLockerLocationList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    const importLockerCsvData = (file: any) => {
        setImportLoading(true)
        setOpenAlertDialog(true)
        const formData = new FormData();
        formData.append('file', file);
        add({
            endpoints: endpoints.locker.import,
            onSuccess: (data: any) => {
                setImportLoading(false)
                refetchData({ isMainTable: showApproved })
                setImportData(data.data)
                setOpenAlertDialog(true)
                toast.success(data.message, { style: { background: '#3150A1' } })

            },
            onError: (error: any) => {
                refetchData({ isMainTable: showApproved })
                toast.error(error.message ?? error)
                setImportLoading(false)
                setOpenAlertDialog(false)
            },
            values: formData
        })
    }

    const downloadLockerDemoCsv = () => {
        window.open('./LockerDemo.xlsx', '_blank');
    }

    const onSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelecteds = rows?.map((n: any) => n.id);
            setSelectedLocker(newSelecteds);
            return;
        } else {
            setSelectedLocker([]);
        }
    }

    const bulkApprove = () => {
        setBulkLoading(true)
        if (selectedLocker.length > 0) {
            edit({
                endpoints: endpoints.locker.bulkApproved,
                onSuccess: (data: any) => {
                    setBulkLoading(false)
                    setSkip(0)
                    setTake(10)
                    setSelectedLocker([])
                    refetchData({ isMainTable: showApproved })
                    toast.success(data.message, { style: { background: '#3150A1' } })
                },
                onError: (error: any) => {
                    setBulkLoading(false)
                    toast.error(error.message ?? error)
                },
                values: selectedLocker
            })
        } else {
            setBulkLoading(false)
            toast.error('Please select at least one locker to approve')
        }
    }

    useEffect(() => {
        setLoading(true)
        getFilterSelectData()
        refetchData({ lockerNo: getValues()?.lockerNo, lockerType: getValues()?.lockerType, lockerLocation: getValues()?.lockerLocation, lockerStatus: getValues()?.lockerStatus, isMainTable: showApproved })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip, take])

    return (<>
        {bulkLoading && <Box sx={{ zIndex: '99', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', background: 'black', position: 'fixed', width: '100%', top: '0px', left: '0px', opacity: '0.4' }}>
            <CircularProgress />
        </Box>}
        <Grid container spacing={1} style={{ marginBottom: "24px", display: 'flex', justifyContent: 'right' }}>
            <Grid item>
                <Button onClick={() => {
                    setSkip(0)
                    setTake(10)
                    setShowApproved('true')
                    refetchData({ isMainTable: 'true' });
                }} variant="contained" disabled={loading}
                    sx={{ padding: '4px 8px', backgroundColor: showApproved === 'true' ? '#07bc0c' : '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: showApproved === 'true' ? '#07bc0c' : null } }}>
                    <ListAlt />
                    <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Approved List</Typography>
                </Button>
            </Grid>
            <Grid item>
                <Button onClick={() => {
                    setSkip(0)
                    setTake(10)
                    setShowApproved('false')
                    refetchData({ isMainTable: 'false' });
                }} variant="contained" disabled={loading} sx={{ padding: '4px 8px', backgroundColor: showApproved === 'false' ? '#07bc0c' : '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: showApproved === 'false' ? '#07bc0c' : null } }}>
                    <Checklist />
                    <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Need to Approve</Typography>
                </Button>
            </Grid>
            {
                showApproved === 'false' && selectedLocker.length > 0 ? <Grid item>
                    <LoadingButton
                        loadingPosition="end"
                        loading={bulkLoading}
                        onClick={() => bulkApprove()}
                        variant="contained"
                        disabled={loading}
                        sx={{ backgroundColor: '#3150A1', marginLeft: '16px', minWidth: '160px', '&:hover': { backgroundColor: '#3150A1', } }}>
                        {bulkLoading ? "Updating..." : <>
                            <Check />
                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Bulk Approve</Typography>
                        </>}
                    </LoadingButton>
                </Grid> : null
            }

            {
                user?.role?.toLowerCase() !== 'checker' ? <>
                    <Grid item>
                        <Button onClick={() => setOpen(true)} disabled={loading} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                            <AddIcon />
                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>New Locker</Typography>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={() => downloadLockerDemoCsv()} disabled={loading} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                            <ArrowUpward />
                            <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Download</Typography>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            sx={{ backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}
                            component="label"
                            variant="contained"
                            disabled={loading}
                            startIcon={<ArrowDownward />}
                            href="#file-upload"
                        >
                            Import
                            <input
                                type="file"
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                style={{ display: 'none' }}
                                onClick={(event: any) => { event.target.value = null }}
                                onChange={(event: any) => {
                                    const file = event.target.files[0];
                                    if (file) {
                                        importLockerCsvData(file)
                                    }
                                }}
                            />
                        </Button>
                    </Grid>
                </> : null
            }
        </Grid>
        <Typography sx={{ color: 'gray', fontSize: '13px', marginBottom: '12px' }}>Search Locker</Typography>
        <form>
            <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: "24px" }}>
                <Grid item xs={2}>
                    <ControlledInput name="lockerNo" control={control} errors={errors} label="Locker number" size={'small'} />
                </Grid>
                <Grid item xs={2}>
                    <CustomSelect height='2.5rem' label="Locker Type" name="lockerType" errors={errors?.lockerType?.message} control={control} values={lockerTypeList ?? []} size={12} setValue={setValue} />
                </Grid>
                <Grid item xs={3}>
                    <CustomSelect height='2.5rem' label="Locker Location" name="lockerLocation" errors={errors?.lockerLocation?.message} control={control} values={lockerLocationList ?? []} size={12} setValue={setValue} />
                </Grid>
                <Grid item xs={3}>
                    <CustomSelect height='2.5rem' label="Locker Status" name="lockerStatus" errors={errors?.lockerStatus?.message} control={control} values={lockerStatusList ?? []} size={12} setValue={setValue} isEnum={true} />
                </Grid>
                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'right' }}>
                    <LoadingButton loading={buttonLoading} onClick={() => resetSearch()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} >Reset</LoadingButton>
                    <LoadingButton type='submit' loading={buttonLoading} onClick={(e) => { e.preventDefault(); handleSubmit(handleSearchButtonClick)() }} variant="contained" sx={{ marginLeft: '16px', padding: '4px 8px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' } }} ><Search /></LoadingButton>
                </Grid>
            </Grid>
        </form>

        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {
                                showApproved === 'false' ? <TableHeadCell align="left" minwidth='40px'>
                                    <Checkbox
                                        color="primary"
                                        indeterminate={selectedLocker.length > 0 && selectedLocker.length < rows?.length}
                                        checked={rows?.length > 0 && selectedLocker.length === rows?.length}
                                        onChange={onSelectAllClick}
                                        inputProps={{ 'aria-label': 'select all locker' }}
                                        style={{ padding: '0px' }}
                                    />
                                </TableHeadCell> : null
                            }
                            <TableHeadCell>S.N</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Locker Number</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Locker Type</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Branch</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Locker Location</TableHeadCell>
                            <TableHeadCell align="left">Status</TableHeadCell>
                            <TableHeadCell align="center">Actions</TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!rows || loading ? <TableRowsLoader rowsNum={5} colNum={7} />
                            : rows?.length <= 0 ? <TableRow>
                                <TableCell colSpan={8} align='center'>No Data Found</TableCell>
                            </TableRow>
                                : rows.map((row: any, index: number) => {
                                    const labelId: (any) = `enhanced-table-checkbox-${index}`;
                                    const isItemSelected: (any) = selectedLocker.indexOf(row.id) !== -1;
                                    return (
                                        <Tooltip sx={{ backgroundColor: '#121212' }} title={
                                            <Box>
                                                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                    <Box height="10px" width="10px" sx={{ backgroundColor: '#3150A1', padding: '6px' }}>
                                                    </Box>
                                                    <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Created By: {row?.createdUser ?? "N/A"}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                    <Box height="10px" width="10px" sx={{ backgroundColor: '#f1c40f', padding: '6px' }}>
                                                    </Box>
                                                    <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Updated By: {row?.updatedUser ?? "N/A"}</Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", gap: "10px", justifyContent: 'start', alignItems: 'center' }}>
                                                    <Box height="10px" width="10px" sx={{ backgroundColor: '#07bc0c', padding: '6px' }}>
                                                    </Box>
                                                    <Typography style={{ fontSize: "12px", fontWeight: "600" }}>Verified By: {row?.verifiedUser ?? "N/A"}</Typography>
                                                </Box>
                                            </Box>
                                        } placement="bottom" arrow key={index}>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}  >
                                                {
                                                    showApproved === 'false' ? <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color="primary"
                                                            checked={isItemSelected}
                                                            onChange={(event: any) => {
                                                                const selectedIndex = selectedLocker.indexOf(row.id);
                                                                let newSelected: readonly number[] = [];
                                                                if (selectedIndex === -1) {
                                                                    newSelected = newSelected.concat(selectedLocker, row.id);
                                                                } else if (selectedIndex === 0) {
                                                                    newSelected = newSelected.concat(selectedLocker.slice(1));
                                                                } else if (selectedIndex === selectedLocker.length - 1) {
                                                                    newSelected = newSelected.concat(selectedLocker.slice(0, -1));
                                                                } else if (selectedIndex > 0) {
                                                                    newSelected = newSelected.concat(
                                                                        selectedLocker.slice(0, selectedIndex), selectedLocker.slice(selectedIndex + 1),
                                                                    );
                                                                }
                                                                setSelectedLocker(newSelected);
                                                            }}
                                                            inputProps={{
                                                                'aria-labelledby': labelId,
                                                            }}
                                                        />
                                                    </TableCell> : null
                                                }
                                                <TableCell style={{ fontSize: "12px" }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>{row.lockerNumber}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>{row.lockerType}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>{row.branchName}</TableCell>
                                                <TableCell align="left" style={{ fontSize: "12px" }}>{row.locationName}</TableCell>
                                                <TableCell align="left">
                                                    <Chip style={{ backgroundColor: getStatusColor(row.status), color: 'white', fontSize: "12px" }} label={row.lockerStatus} />
                                                </TableCell>
                                                <TableCell>
                                                    <Actions onDelete={deleteAction} onEdit={editAction} onView={viewAction} row={row}
                                                        showEdit={user?.role?.toLowerCase() !== 'checker' && showApproved === 'true'}
                                                        showDelete={user?.role?.toLowerCase() !== 'checker' && showApproved === 'true'}
                                                        showView={true}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        </Tooltip>
                                    )
                                })}
                    </TableBody>
                </Table>
            </TableContainer>
            {rows && (rows?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>
        <DeleteAlertModal
            onSuccess={onSuccess}
            onError={onError}
            endpoint={endpoints.locker.api}
            selectedId={selectedId}
            openAlertModal={openAlertModal}
            setOpenAlertModal={setOpenAlertModal}
        />
        <CustomAlertModal
            customEndpoint={true}
            onSuccess={onSuccess}
            onError={onError}
            endpoint={endpoints.locker.approved({ lockerId: selectedId })}
            selectedId={selectedId}
            openAlertModal={openApproveModal}
            setOpenAlertModal={setOpenApproveModal}
            message={'Are you sure want to approve this locker?'}
        />
        <AlertDialog
            open={openAlertDialog}
            setOpen={setOpenAlertDialog}
            title={'Locker Import Status'}
        >
            {isImporting ? <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <CircularProgress />
                <p>uploading ....</p>
            </Box> : <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Existing Lockers ({importData?.alreadyExist?.length ?? 0}): {
                        importData?.alreadyExist && importData?.alreadyExist?.length > 0 ? importData?.alreadyExist.map((item: any) => {
                            return <Chip color={'primary'} label={item} sx={{ fontWeight: "normal" }} />
                        }) : null
                    }</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Duplicate Data ({importData?.duplicate?.length ?? 0}): {
                        importData?.duplicate && importData?.duplicate?.length > 0 ? importData?.duplicate.map((item: any) => {
                            return <Chip color={'warning'} label={item} sx={{ fontWeight: "normal" }} />
                        }) : null
                    }</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Failed Due to Validation ({importData?.validation?.length ?? 0}): {
                        importData?.validation && importData?.validation?.length > 0 ? importData?.validation.map((item: any) => {
                            return <Chip color={'error'} label={item} sx={{ fontWeight: "normal" }} />
                        }) : null
                    }</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>Imported Lockers ({importData?.uploadedLocker?.length ?? 0}): {
                        importData?.uploadedLocker && importData?.uploadedLocker?.length > 0 ? importData?.uploadedLocker.map((item: any) => {
                            return <Chip color={'success'} label={item} sx={{ fontWeight: "normal" }} />
                        }) : null
                    }</Typography>
                </Grid>
            </Grid>}
        </AlertDialog>
    </>
    );
}
